<router-outlet></router-outlet>
@if (isSpinnerVisible) {
  <div class="loader">
    <mat-spinner mode="indeterminate" value="40"></mat-spinner>
  </div>
}
